<template>
  <div class="profile-input-wrapper">
    <profile-form ref="form" endpoint="gender" @error="onError($event)">
      <form id="gender-profile" class="form">
        <fieldset>
          <legend class="sr-only">{{ inputTitle }}</legend>
          <span class="profile-input-label">{{ listLabel }}</span>
          <div class="input radio">
            <label class="profile-input-radio" v-for="gender in genders" :key="gender.value">
              <input
                @input="selectedGender = $event.target.value"
                v-model="localProfile.gender"
                type="radio"
                name="gender"
                :id="gender.value"
                :value="gender.value"
                data-val="true"
                :data-val-required="getValidationForField('required', 'gender')"
                data-field-type="RadioButtonList"
              />
              {{ gender.label }}
            </label>
          </div>
          <div v-show="Number(selectedGender) === 4" class="input">
            <input
              v-model="localProfile.identity"
              :class="[
                { 'no-value': !localProfile.identity },
                { valid: !!localProfile.identity },
                { 'input-validation-error': error }
              ]"
              v-on:input="onInput"
              type="text"
              id="identity"
              ref="identity"
              name="identity"
              class="req"
              data-field-type="SingleLineText"
            />
            <label for="identity" class="req floating">
              {{ tc('profile.formFields.identity') }}
            </label>
            <span
              v-if="error"
              data-valmsg-for="identity"
              data-valmsg-replace="true"
              class="field-validation-error"
              >{{ error }}</span
            >
          </div>
        </fieldset>
      </form>
    </profile-form>
  </div>
</template>

<script>
  import ProfileInputMixin from '@mixins/profile-input-mixin'

  export default {
    name: 'profile-gender-input',
    mixins: [ProfileInputMixin],
    props: {
      genders: {
        type: Array,
        required: true
      },
      listLabel: {
        type: String
      }
    },
    data: () => ({
      localProfile: {
        gender: '',
        identity: ''
      },
      selectedGender: null,
      error: null
    }),
    computed: {
      userGender() {
        return this.localProfile.gender
      }
    },
    mounted() {
      this.selectedGender = this.userGender || null
    },
    methods: {
      onError(event) {
        if (!this.localProfile.identity) {
          this.error = this.getValidationForField('required', 'identity')
        }

        this.$emit('done', event)
      },
      onInput() {
        if (this.localProfile.identity) {
          this.error = null
        } else {
          this.error = this.getValidationForField('required', 'identity')
        }
      }
    }
  }
</script>
